// extracted by mini-css-extract-plugin
export default {"base":"PieChartDisplay_base__PlzoO","select":"PieChartDisplay_select__O5HJZ"};